export default __webpack_public_path__ + "static/media/rock8.1766b501.jpg";